import { useContext, useEffect, useState } from "react";
import {
  Accordion,
  Col,
  Container,
  Dropdown,
  Navbar,
  Row,
  Button,
} from "react-bootstrap";
import { DataContex } from "../../context/DataContext";

import styles from "./Recursos.module.scss";
// import shareStyles from '../../scss/sharedStyles.module.scss'
import { MaterialDownloader } from "../MaterialDownloader/MaterialDownloader";
// import { clearConfig } from "dompurify";

const ordenarMaterialPorCriterio = (material, criterio) =>
  material.sort((a, b) => {
    const keyA = a.title + a.metrialID;
    const keyB = b.title + b.metrialID;

    if (criterio === "asc") {
      return keyA.localeCompare(keyB);
    } else if (criterio === "desc") {
      return keyB.localeCompare(keyA);
    } else {
      // Si el criterio no es válido, no se realiza la ordenación
      return 0;
    }
  });
  

const Recursos = () => {
  const { obrasRecursos, recursosMapeadosFire } = useContext(DataContex);

  const [recursosSorted, setRecursosSorted] = useState([]);

  const [tipoDeOrden, setTipoDeOrden] = useState("asc");

  const [listaObras, setListaObras] = useState([]);

  const [obraFiltrada, setObraFiltrada] = useState("Todas");

  const [tipoDeMaterial, setTipoDeMaterial] = useState("Todos");

  const [cicloFiltrado, setCicloFiltrado] = useState({
    inicial: true,
    primerCiclo: true,
    segundoCiclo: true,
    tercerCiclo: true,
    secundario: true,
    text: "Todos",
  });

  const filtrarPorCiclo = (recurso) => {
    if (cicloFiltrado.text === "Todos") return true;
    const nivelMap = {
      "Inicial": "inicial",
      "Primer ciclo": "primerCiclo",
      "Segundo ciclo": "segundoCiclo",
      "Tercer ciclo": "tercerCiclo",
      "Secundario": "secundario"
    };
    return recurso.niveles?.includes(nivelMap[cicloFiltrado.text]);
  };

  const filtrarPorTipo = (recurso) => {
    if (tipoDeMaterial === "Todos") return true;
    return recurso.tipo === tipoDeMaterial;
  };

  const filtrarPorObra = (recurso) => {
    if (obraFiltrada === "Todas") return true;
    return recurso.title === obraFiltrada;
  };

  const contarRecursosFiltrados = () => {
    return recursosSorted.filter(recurso => 
      filtrarPorObra(recurso) && 
      filtrarPorTipo(recurso) && 
      filtrarPorCiclo(recurso)
    ).length;
  };



  useEffect(() => {
    setRecursosSorted(
      ordenarMaterialPorCriterio(recursosMapeadosFire, tipoDeOrden)
    ); //obrasRecursos recursosMapeadosFire
    const obrasSet = new Set();
    recursosSorted.forEach((obra) => {
      obrasSet.add(obra.title);
    });
    const listaObras = Array.from(obrasSet);
    setListaObras(listaObras);
  }, [obrasRecursos, recursosMapeadosFire, recursosSorted, tipoDeOrden]);

  const Recurso = ({
    title,
    metrialID,
    link,
    description,
    niveles,
    tipo,
    descargas,
    id,
  }) => {
    const data = {
      title,
      metrialID,
      link,
      description,
      niveles,
      tipo,
      descargas,
      id,
    };

    return (
      <Col className={`${styles.recurso}`}>
        <strong>
          <h4>{description}</h4>
          <p>{title}</p>
        </strong>
     
        <MaterialDownloader data={data} />
      </Col>
    );
  };

  console.log(recursosSorted.slice(0, 3))



  return (
    <Container className={styles.recursos}>
      <Row className={`mb-5 align-items-end ${styles.recurosHeader}`}>
        <Col>
          <h2>{recursosSorted.length} Guías didácticas y actividades</h2>
          <h4>
            {" "}
            En este apartado hay investigaciones, actividades y crucigramas para
            descargar.
          </h4>
          <p>
            {" "}
            <b>
              Están agrupados según las siguientes categorías en orden
              alfabético:
            </b>
            <br />
            <span className={styles.categoriaLinks}>
              {Array.from(listaObras).map((obra, index) => (
                <Button
                  key={index}
                  variant="link"
                  className={`${styles.categoriaLink} ${obra === obraFiltrada ? styles.categoriaActiva : ''}`}
                  onClick={() => setObraFiltrada(obra)}
                >
                  • {obra}
                </Button>
              ))}
            </span>
          </p>
        </Col>
      </Row>
      <Navbar sticky='top' className={`mb-5 ${styles.filterBar}`}>
        <Container className={`${styles.filterBarContainer}`} fluid>
          <Accordion defaultActiveKey='0' style={{ width: "100%" }} className={styles.accordionCustom}>
            <Accordion.Item eventKey='0'>
              <Accordion.Header>
                Filtrar por: {contarRecursosFiltrados()} {contarRecursosFiltrados() === 1 ?' material encontrado para' : 'materiales encontrados para'} 
                {obraFiltrada !== "Todas" && ` • ${obraFiltrada}`}
                {tipoDeMaterial !== "Todos" && ` • ${tipoDeMaterial}`}
                {cicloFiltrado.text !== "Todos" && ` • ${cicloFiltrado.text}`}
              </Accordion.Header>
              <Accordion.Body>
                <Row style={{ width: "100%" }} className='pb-2'>
                  <Col md={4} className={`${styles.filterContainer}`}>
                    <Col>Categoría</Col>
                    <Col className={`${styles.dropDownContainer}`}>
                      <Dropdown className={`${styles.dropButton}`}>
                        <Dropdown.Toggle id='dropdown-basic'>
                          {obraFiltrada}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{ overflowY: "auto", height: "75vh" }}>
                          <Dropdown.Item
                            onClick={() => setObraFiltrada("Todas")}>
                            Todas
                          </Dropdown.Item>
                          {Array.from(listaObras).map((data, id) => (
                            <Dropdown.Item
                              key={id}
                              onClick={() => setObraFiltrada(data)}>
                              {data}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  </Col>
                  <Col md={2} className={`${styles.filterContainer}`}>
                    <Col>Orden</Col>
                    <Col className={`${styles.dropDownContainer}`}>
                      <Dropdown className={`${styles.dropButton}`}>
                        <Dropdown.Toggle id='dropdown-basic'>
                          {tipoDeOrden === "asc" ? "Ascendente" : "Descendete"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => setTipoDeOrden("desc")}>
                            Descendente
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setTipoDeOrden("asc")}>
                            Ascendente
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  </Col>

                  <Col xs={12} md={3} className={`${styles.filterContainer}`}>
                    <Col>Tipo de Material</Col>
                    <Col className={`${styles.dropDownContainer}`}>
                      <Dropdown className={`${styles.dropButton}`}>
                        <Dropdown.Toggle id='dropdown-basic'>
                          {tipoDeMaterial}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => setTipoDeMaterial("Todos")}>
                            Todos
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setTipoDeMaterial("Actividad")}>
                            Actividades
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setTipoDeMaterial("Investigación")}>
                            Investigaciones
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => setTipoDeMaterial("Crucigrama")}>
                            Crucigramas
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  </Col>
                  <Col xs={12} md={2} className={`${styles.filterContainer}`}>
                    <Col>Ciclo</Col>
                    <Col className={`${styles.dropDownContainer}`}>
                      <Dropdown className={`${styles.dropButton}`}>
                        <Dropdown.Toggle id='dropdown-basic'>
                          {cicloFiltrado.text}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              setCicloFiltrado({
                                inicial: false,
                                primerCiclo: false,
                                segundoCiclo: false,
                                tercerCiclo: false,
                                secundario: false,
                                text: "Todos",
                              })
                            }>
                            Todos
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setCicloFiltrado({
                                inicial: true,
                                primerCiclo: false,
                                segundoCiclo: false,
                                tercerCiclo: false,
                                secundario: false,
                                text: "Inicial",
                              })
                            }>
                            Inicial
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setCicloFiltrado({
                                inicial: false,
                                primerCiclo: true,
                                segundoCiclo: false,
                                tercerCiclo: false,
                                secundario: false,
                                text: "Primer ciclo",
                              })
                            }>
                            Primer ciclo
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setCicloFiltrado({
                                inicial: false,
                                primerCiclo: false,
                                segundoCiclo: true,
                                tercerCiclo: false,
                                secundario: false,
                                text: "Segundo ciclo",
                              })
                            }>
                            Segundo ciclo
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setCicloFiltrado({
                                inicial: false,
                                primerCiclo: false,
                                segundoCiclo: false,
                                tercerCiclo: true,
                                secundario: false,
                                text: "Tercer ciclo",
                              })
                            }>
                            Tercer ciclo
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setCicloFiltrado({
                                inicial: false,
                                primerCiclo: false,
                                segundoCiclo: false,
                                tercerCiclo: false,
                                secundario: true,
                                text: "Secundario",
                              })
                            }>
                            Secundario
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  </Col>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Container>
      </Navbar>
      <ul>
        {Array.from(recursosSorted).map((data, id) => (
          <div key={id}>
            {filtrarPorTipo(data) && filtrarPorObra(data) && filtrarPorCiclo(data) && (
              <Recurso
                title={data.title}
                metrialID={data.metrialID}
                link={data.link}
                description={data.description}
                niveles={data.niveles}
                tipo={data.tipo}
                descargas={data.descargas}
                id={data.id}
              />
            )}
          </div>
        ))}
      </ul>
    </Container>
  );
};

export {
  Recursos,
  ordenarMaterialPorCriterio,
}
